import React, { Component } from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";
class DeleteItemMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  Submit = () => {
    let id = this.props.DeleteItemMaster && this.props.DeleteItemMaster.id;

    this.props.ItemMasterDelete(id);
    this.props.closeItemMasterDelModel();
    this.props.resetPage();
  };
  render() {
    return (
      <div>
        <Modal
          show={this.props.showItemMasterDelModel}
          animation={false}
          size="md"
          backdrop="static"
          centered={true}
          onHide={this.props.closeItemMasterDelModel}
        >
          <Modal.Body>
            {" "}
            <div>
              <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                <b>Delete the item "{this.props.DeleteItemMaster&&this.props.DeleteItemMaster.descp}"?</b>
              </h6>
            </div>
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  className="cmnDelCnclBtn"
                  variant="danger"
                  onClick={() => this.props.closeItemMasterDelModel()}
                >
                  CANCEL
                </Button>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="success"
                  className="cmnDelOkBtn"
                  onClick={this.Submit}
                >
                  OK
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default DeleteItemMaster;
